import { connect, disconnect, isConnected, isConnecting } from '../../em-shared-session/src/connection';


/**
 * Set Default Connection Settings
 */
const currentConfig = { };
let hasDefaults = false;
export function setDefaultConnectionSettings(webapiEndpoint, webapiFallbackEndpoint, webapiDomain) {
    if (hasDefaults) {
        return false;
    }

    if (!webapiEndpoint && !webapiFallbackEndpoint && webapiDomain) {
        return false;
    }

    // save defaults
    currentConfig.webapiEndpoint = webapiEndpoint;
    currentConfig.webapiFallbackEndpoint = webapiFallbackEndpoint;
    currentConfig.webapiDomain = webapiDomain;
    hasDefaults = true;

    // with enough settings, we can now connect
    if (isConnected() || isConnecting()) {
        return true;
    }

    // let's do that
    const transports = [];
    if (webapiEndpoint) {
        transports.push({ type: 'websocket', url: webapiEndpoint });
    }
    if (webapiFallbackEndpoint) {
        transports.push({ type: 'longpoll', url: webapiFallbackEndpoint });
    }
    if (webapiDomain && transports.length) {
        connect({
            realm: webapiDomain,
            transports,
        });
    }

    return true;
}


export function updateConnectionSettings(webapiEndpoint, webapiFallbackEndpoint, webapiDomain) {
    // do we have at least one relevant setting?
    if (!webapiEndpoint && !webapiFallbackEndpoint && !webapiDomain) {
        return;
    }

    // did at least one of those settings change?
    if (
        webapiEndpoint === currentConfig.webapiEndpoint &&
        webapiFallbackEndpoint === currentConfig.webapiFallbackEndpoint &&
        webapiDomain === currentConfig.webapiDomain
    ) {
        return;
    }

    // save new settings
    currentConfig.webapiEndpoint = webapiEndpoint;
    currentConfig.webapiFallbackEndpoint = webapiFallbackEndpoint;
    currentConfig.webapiDomain = webapiDomain;

    // attempt a new connection
    const transports = [];

    if (webapiEndpoint) {
        transports.push({ type: 'websocket', url: webapiEndpoint });
    }

    if (webapiFallbackEndpoint) {
        transports.push({ type: 'longpoll', url: webapiFallbackEndpoint });
    }

    // abide by shared-session connect/disconnect pattern - connect call updates connection settings internally
    if (webapiDomain && transports.length) {
        const shouldDisconnect = isConnected() || isConnecting();
        connect({ transports, realm: webapiDomain });
        if (shouldDisconnect) {
            disconnect();
        }
    }
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/connection.js